import {
  Bold,
  Italic,
  Underline,
  Link as LinkIcon,
  List,
  ListOrdered,
  Quote,
  Heading2,
  Heading3,
} from 'lucide-react';
import type { Editor } from '@tiptap/react';
import type { ReactNode } from 'react';

export type Cfg = {
  mark: string;
  run: (e: Editor) => void;
  title: string;
  icon: ReactNode;
};

function promptLink(e: Editor): void {
  const url = window.prompt('URL (https:// o mailto:)');
  if (!url) return;
  if (!/^(https:\/\/|mailto:)/i.test(url)) {
    window.alert('Solo se permiten URLs https:// o mailto:');
    return;
  }
  e.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
}

export const MARK: Cfg[] = [
  {
    mark: 'bold',
    run: (e) => e.chain().focus().toggleBold().run(),
    title: 'Negrita',
    icon: <Bold size={14} />,
  },
  {
    mark: 'italic',
    run: (e) => e.chain().focus().toggleItalic().run(),
    title: 'Cursiva',
    icon: <Italic size={14} />,
  },
  {
    mark: 'underline',
    run: (e) => e.chain().focus().toggleMark('underline').run(),
    title: 'Subrayar',
    icon: <Underline size={14} />,
  },
];

export const HEADING: Cfg[] = [
  {
    mark: 'heading',
    run: (e) => e.chain().focus().toggleHeading({ level: 2 }).run(),
    title: 'Encabezado 2',
    icon: <Heading2 size={14} />,
  },
  {
    mark: 'heading',
    run: (e) => e.chain().focus().toggleHeading({ level: 3 }).run(),
    title: 'Encabezado 3',
    icon: <Heading3 size={14} />,
  },
];

export const BLOCK: Cfg[] = [
  {
    mark: 'bulletList',
    run: (e) => e.chain().focus().toggleBulletList().run(),
    title: 'Lista',
    icon: <List size={14} />,
  },
  {
    mark: 'orderedList',
    run: (e) => e.chain().focus().toggleOrderedList().run(),
    title: 'Lista numerada',
    icon: <ListOrdered size={14} />,
  },
  {
    mark: 'blockquote',
    run: (e) => e.chain().focus().toggleBlockquote().run(),
    title: 'Cita',
    icon: <Quote size={14} />,
  },
  {
    mark: 'link',
    run: promptLink,
    title: 'Enlace',
    icon: <LinkIcon size={14} />,
  },
];
